import { createAsyncThunk } from '@reduxjs/toolkit';
import { getDeliveryReceiptDocument } from '@api/GenerateReceipt.ts';
import { handleReduxError } from '@utils/requests.ts';
import { i18n } from '@components/i18n.ts';

interface FetchDeliveryReceiptDocumentProps {
  processObjectId: string;
  documentType: string;
  fileName: string;
}
export const fetchDeliveryReceiptDocumentThunk = createAsyncThunk(
  'deliveryReceipt/fetchDeliveryReceiptDocument',
  async (
    {
      processObjectId,
      documentType,
      fileName,
    }: FetchDeliveryReceiptDocumentProps,
    { rejectWithValue }
  ) => {
    try {
      return await getDeliveryReceiptDocument({
        processObjectId: processObjectId,
        documentType: documentType,
        fileName: fileName,
      });
    } catch (error: unknown) {
      return rejectWithValue(handleReduxError(error, i18n.t));
    }
  }
);
